module.exports = __webpack_public_path__ + "img/sort-arrow-asc.6b8a4617.svg";